<template>
  <div class="subscription-plans container py-4">
    <div class="row justify-content-center">
      <!-- Subscription Plan Card (with user status and actions) -->
      <div v-for="plan in plans" :key="plan.id" class="col-12 col-md-12 d-flex justify-content-center mb-4">
        <div class="card shadow w-100" style="max-width: 400px;">
          <div class="card-body text-center">
            <h4 class="card-title font-weight-bold mb-2">{{ plan.title || 'Membership Plan' }}</h4>
            <div v-if="plan.price !== undefined" class="display-4 mb-2">${{ plan.price ? plan.price.toFixed(2) : '0.00'
            }} <span class="h5 font-weight-normal" style="color: #888;">/month</span></div>
            <div class="plan-description" v-html="decodeHTML(plan.description)"></div>
            <!-- Subscription Status Details -->
            <!-- inside v-for="plan in plans" -->
            <!-- <div v-if="!loadingStatus"> -->
              <div v-if="subscription.exists && subscription.planId === plan.id">
                <!-- Matching subscribed plan -->
                <div class="mb-2">
                  <!-- <span class="badge badge-success" v-if="subscription.isActive">Active</span> -->
                  <span class="badge" :class="{'badge-success-black': isTheRouteForStaff, 'badge-success-blue': !isTheRouteForStaff }">{{ subscription.status }}</span>
                </div>
                <div v-if="subscription.validTill" class="mb-2">Valid till: {{ formattedValidTill }}</div>

                <div v-if="subscription.canceled">
                  <div class="alert alert-info py-2">Subscription will automatically cancel at period end.</div>
                  <button class="btn btn-danger mt-2" disabled>Cancel Subscription</button>
                </div>
                <div v-else>
                  <button class="btn btn-danger mt-2" :disabled="cancelling" @click="onCancel">
                    <span v-if="cancelling" class="spinner-border spinner-border-sm"></span>
                    <span v-else>Cancel Subscription</span>
                  </button>
                </div>
              </div>

              <div v-else>
                <!-- Not the active subscribed plan -->
                <button class="btn mt-2"
                  :class="{ 'btn-primary-black': isTheRouteForStaff, 'btn-primary': !isTheRouteForStaff }"
                  :disabled="subscription.exists || subscribing" @click="onSubscribe(plan.id)">
                  <span v-if="subscribingPlanId === plan.id" class="spinner-border spinner-border-sm"></span>
                  <span v-else>Subscribe</span>
                </button>
              </div>
            <!-- </div> -->

            <div v-else class="my-4">
              <span class="spinner-border"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';
import dayjs from 'dayjs';
import { eventBus } from "@/main";

export default {
  name: 'TrainingCoursesSubscriptions',
  data() {
    return {
      plans: [],
      subscription: {
        id: '',
        exists: false,
        isActive: false,
        status: '',
        validTill: null,
        canceled: false,
        planId: ''
      },
      loadingStatus: true,
      subscribing: false,
      cancelling: false,
      subscribingPlanId: null,
      stripePublicKey:'pk_test_51RbgpqEEhA8eKaKSLhG4ue2rYlm2nvgEaQFr3cGkzZgHvCal0kyXQ9E5KcPU0zi3GFgzj1O0lwV6W8b37fokeG8Q000on1Ov79'
    };
  },
  methods: {
    /**
     * Fetches the available subscription plan from the backend API.
     * Updates the 'plan' data property with the plan details.
     * Handles both array and object response formats.
     * @returns {Promise<void>}
     */
    async fetchPlan() {
      try {
        const res = await axios.get('/subscription/plans');
        if (res.data && res.data.plans && res.data.plans.length > 0) {
          this.plans = res.data.plans;
        } else if (Array.isArray(res.data) && res.data.length > 0) {
          this.plans = res.data;
        } else {
          this.plans = [];
        }
      } catch (e) {
        this.plans = [];
      }
    },
    /**
     * Fetches the user's current subscription status from the backend API.
     * Updates the 'subscription' data property with status, validity, and cancellation info.
     * @returns {Promise<void>}
     */
    async fetchStatus() {
      this.loadingStatus = true;
      try {
        const res = await axios.get('/subscription/status');
        if (res.data) {
          this.subscription.id = res.data.subscription_id,
            this.subscription.exists = !!res.data.has_subscription;
          this.subscription.isActive = !!res.data.active;
          this.subscription.status = res.data.status || '';
          this.subscription.validTill = res.data.valid_till || null;
          this.subscription.canceled = res.data.is_canceled || false;
          this.subscription.planId = res.data.plan_id || '';
        }
      } catch (e) {
        this.subscription = { exists: false, isActive: false, status: '', validTill: null, canceled: false, planId: null };
      } finally {
        this.loadingStatus = false;
      }
    },
    /**
     * Initiates the Stripe Checkout flow for subscribing to the plan.
     * Handles loading state and error toasts.
     * @returns {Promise<void>}
     */
    async onSubscribe(planId) {
      let redirectUrl = '';
      if (this.$route.path.includes('/restaurant')) {

        if (this.$store.getters.redirectBackTo == 'shift-create') {

          console.log('Returning to create base: ', this.$store.state.redirectTo);
          redirectUrl = '/restaurant/shift/create';

        } else {

          redirectUrl = '/restaurant/subscriptions';

        }
      }

      if (this.$route.path.includes('/staff')) {
        if (this.$store.getters.redirectBackTo == 'training-courses') {

          console.log('Returning to create base: ', this.$store.state.redirectTo);
          redirectUrl = '/staff/training-courses';

        } else {

          redirectUrl = '/staff/subscriptions';

        }
      }

      console.log('Redirect Url', redirectUrl);

      this.subscribingPlanId = planId;
      try {
        const res = await axios.post('/subscription/subscribe', { plan_id: planId, redirect_url: redirectUrl });
        if (res.data && res.data.session_id) {
          // console.log(VUE_APP_STRIPE_PUBLIC_KEY, process.env.VUE_APP_STRIPE_PUBLIC_KEY)
          // const stripe = await loadStripe(VUE_APP_STRIPE_PUBLIC_KEY);
          console.log('STRIPE_PUBLIC_KEY', this.stripePublicKey);
          const stripe = await loadStripe(this.stripePublicKey);
          await stripe.redirectToCheckout({ sessionId: res.data.session_id });
        } else {
          this.$bvToast && this.$bvToast.toast('Could not start subscription. Error occurred.', {
            title: 'Subscription',
            autoHideDelay: 5000,
          });
        }
      } catch (e) {
        this.$bvToast && this.$bvToast.toast('Could not start subscription. Error occurred.', {
          title: 'Subscription',
          autoHideDelay: 5000,
        });
      } finally {
        this.subscribingPlanId = null;
      }
    },
    /**
     * Sends a request to cancel the user's subscription at period end.
     * Shows a confirmation dialog, handles loading state, and displays toasts.
     * Refreshes the subscription status after cancellation.
     * @returns {Promise<void>}
     */
    async onCancel() {
      if (!confirm('Are you sure you want to cancel your subscription? You will retain access until the end of the current period.')) return;
      this.cancelling = true;
      try {
        const res = await axios.post('/subscription/cancel', { 'subscription_id': this.subscription.id });
        if (res.data && res.data.canceled) {
          this.$bvToast && this.$bvToast.toast('Subscription cancelled. You will retain access until the end of the current period.', {
            title: 'Subscription',
            autoHideDelay: 5000,
          });
          await this.fetchStatus();
        } else {
          this.$bvToast && this.$bvToast.toast('Could not cancel subscription. Error occurred.', {
            title: 'Subscription',
            autoHideDelay: 5000,
          });
        }
      } catch (e) {
        this.$bvToast && this.$bvToast.toast('Could not cancel subscription. Error occurred.', {
          title: 'Subscription',
          autoHideDelay: 5000,
        });
      } finally {
        this.cancelling = false;
      }
    },

    decodeHTML(encodedStr) {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = encodedStr;
      return textarea.value;
    }
  },
  computed: {
    /**
     * Returns the formatted validTill date in a human-readable format, or an empty string if not set.
     * @returns {string}
     */
    formattedValidTill() {
      if (!this.subscription.validTill) return '';
      // return dayjs(this.subscription.validTill).format('MMM D, YYYY, HH:mm');
      return dayjs(this.subscription.validTill).format('MMM D, YYYY');
    },

    isTheRouteForStaff() {
      return this.$route.path.includes('/staff');
    }
  },
  /**
   * Lifecycle hook: Fetches the plan and subscription status on component mount.
   * @returns {Promise<void>}
   */
  async mounted() {
    let loader = this.$loading.show();

    eventBus.$emit('changeTop', { title: 'My Subscriptions', simple: true, topLogo: false });
    await this.fetchPlan();

    if (!this.subscription.exists) {
      // Check for session_id in query params
      const sessionId = this.$route.query.session_id;
      // console.log('SessionId:', sessionId);
      if (sessionId) {
        this.$bvToast && this.$bvToast.toast('Successfully subscribed!', {
          title: 'Subscription',
          autoHideDelay: 5000,
        });
        this.$router.replace({ query: { ...this.$route.query, session_id: undefined } });
      }
    }

    await this.fetchStatus();
    loader.hide();
    if (this.$route.query['redirectTo'] === 'shift-create') {
      // Store the flag in Vuex
      this.$store.commit('setRedirectTo', 'shift-create');

      //Remove the query param from the URL without reloading the page
      // const query = { ...this.$route.query };
      // delete query['create-base'];
      // this.$router.replace({ query });
    }

    if (this.$route.query['redirectTo'] === 'training-courses') {
      this.$store.commit('setRedirectTo', 'training-courses');
    }
  }
};
</script>